module.exports = __webpack_public_path__ + "static/media/channel-active.ce4e1e56.svg";